/**
 * MP Bestsellers / collection quick-add variant picker (chip modals).
 * Binds chip selection to variant id + price inside modal-dialog.mp-bs-picker.
 */
(function () {
  'use strict';

  var ACTIVATE_MS = 400;

  function bindPicker(modal) {
    if (!modal || modal.__mpBsBound) return;

    var jsonNode = modal.querySelector('script[data-mp-bs-variants]');
    if (!jsonNode) return;

    var variants = [];
    try {
      variants = JSON.parse(jsonNode.textContent);
    } catch (err) {
      return;
    }

    modal.__mpBsBound = true;

    var idInput = modal.querySelector('[data-mp-bs-id]');
    var priceEl = modal.querySelector('[data-mp-bs-price]');
    var submitBtn = modal.querySelector('[data-mp-bs-submit]');
    var labelEl = modal.querySelector('.mp-bs-picker__submit-label');
    var groups = modal.querySelectorAll('[data-mp-bs-position]');
    var lastChip = null;
    var lastActivate = 0;

    function getSelectedValues() {
      var values = [];
      groups.forEach(function (group) {
        var chip = group.querySelector('[data-mp-bs-chip].is-selected');
        values.push(chip ? chip.getAttribute('data-mp-bs-value') : null);
      });
      return values;
    }

    function findVariant(values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (v.opts[j] !== values[j]) {
            match = false;
            break;
          }
        }
        if (match) return v;
      }
      return null;
    }

    function refresh() {
      var values = getSelectedValues();
      var v = findVariant(values);
      if (v && v.available) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
          submitBtn.removeAttribute('aria-disabled');
        }
        if (labelEl) labelEl.textContent = 'Dodaj do koszyka';
      } else if (v && !v.available) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = v.price;
        if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
        if (labelEl) labelEl.textContent = 'Wyprzedane';
      } else {
        if (submitBtn) submitBtn.setAttribute('aria-disabled', 'true');
        if (labelEl) labelEl.textContent = 'Wybierz opcje';
        if (priceEl) priceEl.textContent = '';
      }
    }

    function selectChip(chip) {
      if (!chip || chip.disabled) return;
      var group = chip.closest('[data-mp-bs-position]');
      if (!group) return;
      group.querySelectorAll('[data-mp-bs-chip]').forEach(function (c) {
        c.classList.remove('is-selected');
      });
      chip.classList.add('is-selected');
      refresh();
    }

    function activateChip(chip) {
      var now = Date.now();
      if (chip === lastChip && now - lastActivate < ACTIVATE_MS) return;
      lastChip = chip;
      lastActivate = now;
      selectChip(chip);
    }

    function onChipPointer(event) {
      var chip = event.target.closest('[data-mp-bs-chip]');
      if (!chip || !modal.contains(chip)) return;
      activateChip(chip);
    }

    // pointerup works reliably on iOS inside fixed modals; click covers desktop/mouse.
    modal.addEventListener('pointerup', onChipPointer);
    modal.addEventListener('click', onChipPointer);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || !event.productVariantId) return;
        if (!idInput) return;
        if (String(event.productVariantId) === String(idInput.value) && modal.hasAttribute('open')) {
          if (typeof modal.hide === 'function') modal.hide();
          else modal.removeAttribute('open');
        }
      });
    }

    refresh();
  }

  function bindAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.mp-bs-picker').forEach(bindPicker);
  }

  window.MpBsPicker = {
    bind: bindPicker,
    bindAll: bindAll,
  };

  function init() {
    bindAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    bindAll(event.target);
  });
})();
